import { Reveal } from "./Reveal";
import { IMAGES } from "../data/content";

export const QualityBanner = () => (
  <section data-testid="quality-banner" className="relative flex min-h-[75vh] items-center overflow-hidden">
    <img src={IMAGES.stairs} alt="Detaj mjeshtërie metalike" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-ink/80" />
    <div className="absolute inset-0 texture-grain" />
    <div className="relative mx-auto w-full max-w-7xl px-5 py-24 sm:px-8">
      <Reveal>
        <p className="eyebrow mb-5">Mjeshtëria jonë</p>
        <h2 data-testid="quality-title" className="max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-6xl">
          Cilësi që ndërtohet për të zgjatur
        </h2>
        <p data-testid="quality-text" className="mt-8 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg">
          Çdo projekt realizohet me kujdes maksimal, duke i kushtuar rëndësi çdo detaji – nga përgatitja dhe përpunimi i materialit deri te përfundimi final. Ne ofrojmë cilësi, precizion dhe qëndrueshmëri, ndërsa për çdo projekt të realizuar nga ana jonë ofrojmë garanci për punën e kryer.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-12 grid max-w-2xl grid-cols-3 gap-6 border-t hairline pt-8">
          {["Precizion", "Qëndrueshmëri", "Garanci"].map((w) => (
            <p key={w} className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-bronze sm:text-sm">{w}</p>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export const CustomProject = () => (
  <section data-testid="custom-project-section" className="bg-bone py-24 text-ink sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="eyebrow mb-5">Projekt i personalizuar</p>
        <h2 data-testid="custom-project-title" className="max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Nga ideja juaj, në realizimin tonë
        </h2>
        <p data-testid="custom-project-text" className="mt-8 max-w-2xl text-base leading-relaxed text-ink/70 sm:text-lg">
          Pavarësisht nëse bëhet fjalë për një derë oborri, një rrethojë, një shkallë metalike, një tavolinë apo një konstruksion të madh industrial, ekipi ynë është i gatshëm ta realizojë projektin sipas dimensioneve dhe kërkesave tuaja.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <p
          data-testid="custom-project-statement"
          className="mt-16 max-w-5xl font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-5xl lg:text-6xl"
        >
          Ju e keni idenë – <span className="text-bronze">ne e kthejmë atë në metal.</span>
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <a
          href="#kontakt"
          data-testid="custom-project-cta"
          className="mt-12 inline-block border border-ink bg-ink px-8 py-4 font-display text-sm font-semibold uppercase tracking-[0.15em] text-bone transition-colors duration-300 hover:bg-transparent hover:text-ink"
        >
          Kërko ofertë për projektin tuaj
        </a>
      </Reveal>
    </div>
  </section>
);

export const EuropeDelivery = () => (
  <section data-testid="european-delivery-section" className="relative overflow-hidden bg-ink py-24 texture-grain sm:py-32">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-10 top-1/2 -translate-y-1/2 select-none font-display text-[22vw] font-bold leading-none text-outline opacity-60"
    >
      EU
    </div>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="eyebrow mb-5">Përtej kufijve</p>
        <h2 data-testid="europe-title" className="max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
          Transport në të gjithë Evropën
        </h2>
        <p data-testid="europe-text" className="mt-8 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg">
          ALBESI AXH METAL nuk kufizohet vetëm në tregun lokal. Ofron transport dhe realizim të porosive për klientë në të gjithë Evropën, duke ju mundësuar të përfitoni nga produktet dhe punimet tona kudo që ndodheni.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-12 flex max-w-xl items-center gap-4">
          <span className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-white/70">Çellopek, Tetovë</span>
          <span className="relative h-px flex-1 bg-white/15">
            <span className="absolute -top-[3px] right-0 h-[7px] w-[7px] rounded-full bg-bronze" />
          </span>
          <span className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-bronze">E gjithë Evropa</span>
        </div>
      </Reveal>
    </div>
  </section>
);
